import type { ReactNode } from "react"

interface PageLayoutProps {
  title: string
  children: ReactNode
}

export function PageLayout({ title, children }: PageLayoutProps) {
  return (
    <div>
      <div className="tw-border-b tw-py-2">
        <h1 className="tw-text-lg tw-text-center">{title}</h1>
      </div>
      {children}
    </div>
  )
}
